import React from 'react';
import { PlusIcon, MoreHorizontalIcon } from 'lucide-react';
export const TeamSettings = () => {
  const teamMembers = [{
    id: 1,
    name: 'John Doe',
    email: 'john.doe@example.com',
    role: 'Admin',
    avatar: 'JD'
  }, {
    id: 2,
    name: 'Sarah Smith',
    email: 'sarah.smith@example.com',
    role: 'Recruiter',
    avatar: 'SS'
  }, {
    id: 3,
    name: 'Michael Johnson',
    email: 'michael.johnson@example.com',
    role: 'Hiring Manager',
    avatar: 'MJ'
  }, {
    id: 4,
    name: 'Emily Williams',
    email: 'emily.williams@example.com',
    role: 'Recruiter',
    avatar: 'EW'
  }];
  return <div data-id="element-1637">
      <div className="mb-6" data-id="element-1638">
        <h2 className="text-lg font-semibold" data-id="element-1639">Team Management</h2>
        <p className="text-gray-600" data-id="element-1640">
          Manage your team members and their access permissions
        </p>
      </div>
      <div className="bg-white border border-gray-200 rounded-lg overflow-hidden" data-id="element-1641">
        <div className="p-6 flex justify-between items-center border-b border-gray-200" data-id="element-1642">
          <div data-id="element-1643">
            <h3 className="text-lg font-medium" data-id="element-1644">Team Members</h3>
            <p className="text-sm text-gray-500" data-id="element-1645">
              {teamMembers.length} members in your team
            </p>
          </div>
          <button className="flex items-center px-4 py-2 bg-indigo-600 text-white rounded-md hover:bg-indigo-700 transition-colors" data-id="element-1646">
            <PlusIcon size={16} className="mr-1" data-id="element-1647" />
            Add Member
          </button>
        </div>
        <div className="overflow-x-auto" data-id="element-1648">
          <table className="min-w-full divide-y divide-gray-200" data-id="element-1649">
            <thead className="bg-gray-50" data-id="element-1650">
              <tr data-id="element-1651">
                <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1652">
                  Name
                </th>
                <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1653">
                  Email
                </th>
                <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1654">
                  Role
                </th>
                <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1655">
                  Status
                </th>
                <th scope="col" className="relative px-6 py-3" data-id="element-1656">
                  <span className="sr-only" data-id="element-1657">Actions</span>
                </th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200" data-id="element-1658">
              {teamMembers.map(member => <tr key={member.id} data-id="element-1659">
                  <td className="px-6 py-4 whitespace-nowrap" data-id="element-1660">
                    <div className="flex items-center" data-id="element-1661">
                      <div className="h-10 w-10 rounded-full bg-indigo-100 flex items-center justify-center text-indigo-600 font-medium" data-id="element-1662">
                        {member.avatar}
                      </div>
                      <div className="ml-4" data-id="element-1663">
                        <div className="text-sm font-medium text-gray-900" data-id="element-1664">
                          {member.name}
                        </div>
                      </div>
                    </div>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap" data-id="element-1665">
                    <div className="text-sm text-gray-500" data-id="element-1666">{member.email}</div>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap" data-id="element-1667">
                    <select className="text-sm border border-gray-300 rounded-md px-2 py-1" data-id="element-1668">
                      <option selected={member.role === 'Admin'} data-id="element-1669">Admin</option>
                      <option selected={member.role === 'Recruiter'} data-id="element-1670">
                        Recruiter
                      </option>
                      <option selected={member.role === 'Hiring Manager'} data-id="element-1671">
                        Hiring Manager
                      </option>
                      <option selected={member.role === 'Viewer'} data-id="element-1672">
                        Viewer
                      </option>
                    </select>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap" data-id="element-1673">
                    <span className="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-green-100 text-green-800" data-id="element-1674">
                      Active
                    </span>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium" data-id="element-1675">
                    <button className="text-gray-500 hover:text-gray-700" data-id="element-1676">
                      <MoreHorizontalIcon size={16} data-id="element-1677" />
                    </button>
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
      </div>
      <div className="mt-6 bg-white border border-gray-200 rounded-lg p-6" data-id="element-1678">
        <h3 className="text-lg font-medium mb-4" data-id="element-1679">Team Permissions</h3>
        <div className="space-y-4" data-id="element-1680">
          <div className="p-4 border border-gray-200 rounded-lg" data-id="element-1681">
            <div className="flex justify-between items-center" data-id="element-1682">
              <div data-id="element-1683">
                <h4 className="font-medium" data-id="element-1684">Admin</h4>
                <p className="text-sm text-gray-500" data-id="element-1685">
                  Full access to all features and settings
                </p>
              </div>
              <div className="text-xs text-gray-500" data-id="element-1686">1 member</div>
            </div>
          </div>
          <div className="p-4 border border-gray-200 rounded-lg" data-id="element-1687">
            <div className="flex justify-between items-center" data-id="element-1688">
              <div data-id="element-1689">
                <h4 className="font-medium" data-id="element-1690">Recruiter</h4>
                <p className="text-sm text-gray-500" data-id="element-1691">
                  Can manage candidates, conduct screenings, and view analytics
                </p>
              </div>
              <div className="text-xs text-gray-500" data-id="element-1692">2 members</div>
            </div>
          </div>
          <div className="p-4 border border-gray-200 rounded-lg" data-id="element-1693">
            <div className="flex justify-between items-center" data-id="element-1694">
              <div data-id="element-1695">
                <h4 className="font-medium" data-id="element-1696">Hiring Manager</h4>
                <p className="text-sm text-gray-500" data-id="element-1697">
                  Can review candidates and provide feedback
                </p>
              </div>
              <div className="text-xs text-gray-500" data-id="element-1698">1 member</div>
            </div>
          </div>
          <div className="p-4 border border-gray-200 rounded-lg" data-id="element-1699">
            <div className="flex justify-between items-center" data-id="element-1700">
              <div data-id="element-1701">
                <h4 className="font-medium" data-id="element-1702">Viewer</h4>
                <p className="text-sm text-gray-500" data-id="element-1703">
                  Read-only access to candidates and analytics
                </p>
              </div>
              <div className="text-xs text-gray-500" data-id="element-1704">0 members</div>
            </div>
          </div>
        </div>
      </div>
    </div>;
};